import React from 'react'
import { makeStyles, useTheme } from '@material-ui/styles';
import { Typography, Grid, Card  } from '@material-ui/core';
import FormikForm from './FormikForm'
import {useHistory} from 'react-router-dom'


const useStyles = makeStyles(theme => ({
    
    root: {
     display:'flex',
     flexDirection: 'column',
     flex:1,
    //   background: 'green',
      height: "100%"
    },
    gridContainerOuter:{
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: "center",
        justifySelf: "center",
        height: "100%"
    },
    gridItemInner:{
        padding : '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    cardBody: {
        display: 'flex',
        flex:1,
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]:{
            flexDirection: 'column',
            margin:30
        },
    },
    divLogo: {
        padding: 14,
        // borderBottom: '1px solid lightgrey',
        display: 'flex',
        justifyContent: 'center',
    },
    divContent: {
        padding: 12,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        margin: 15,
        maxWidth: '100%',
        width: 450,
        [theme.breakpoints.down('xs')]:{
            width: 250,
        },
      }
}));

function SignIn() {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.root}>
        {/* <div className={classes.titleDiv}>
            <Typography variant="h2">Alerts</Typography>
        </div> */}
        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12} sm={12} md={8} lg={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divLogo}>
                        {/* <Typography variant="h5" color="inherit">
                        title1
                    </Typography> */}
                    <img
              alt="Under development"
              className={classes.image}
              src="/images/enter-1.svg"
            />
                    </div>
                    <div className={classes.divContent}>
                       <FormikForm history={history}/>
                    </div>
                </Card>
            </Grid>
            
        </Grid>

  
    </div>

    )
}

export default SignIn
